export default __webpack_public_path__ + "static/media/resultpagemockup.0c557027.png";